// 15 seconds, how often the data is updated on the operator view
export const M_SECONDS_POOLING_OPERATOR_INTERVAL_DATA = 15 * 1000;
// 10 seconds, how often the data is updated on the setup view.
export const M_SECONDS_POOLING_SETUP = 10 * 1000;
// 1 min, how often the data is updated on the manager view and the dashboard.
export const M_SECONDS_POOLING_INTERVAL_DATA = 60 * 1000;
export const ALARMS_POLLING_INTERVAL = 2 * M_SECONDS_POOLING_INTERVAL_DATA;

// 1 day
export const M_SECONDS_KEEP_UNUSED_DATA_FOR_MAX_CACHE = 1 * 24 * 60 * 60 * 1000;
